// import { tr } from "date-fns/locale";

const RotateIcon = function(options) {
    this.options = options || {};
    this.rImg = options.img || new Image();
    this.rImg.src = this.rImg.src || this.options.url || '';
    this.options.width = this.options.width || 52;
    this.options.height = this.options.height || 60;
    this._canvas = null;
    this._context = null;
    this._hasDrawn = false;
  };
  /**
   * Ảnh nền dùng chung theo URL.
   *
   * Trước đây mỗi lần dựng icon là một `new Image()` mới: lần nào cũng phải tải lại (dù trình duyệt
   * có cache HTTP), nên `complete` thường còn false tại thời điểm vẽ, canvas chưa có gì, và
   * `getUrl()` xuất ra một PNG TRẮNG. Marker biến mất rồi hiện lại ở render sau — đó chính là hiện
   * tượng xe nháy trên bản đồ. Giữ lại một Image cho mỗi URL thì từ lần thứ hai trở đi nó luôn
   * `complete`, vẽ được ngay trong cùng một nhịp render.
   */
  const imageCache = new Map();

  RotateIcon.makeIcon = function(url) {
    let img = imageCache.get(url);
    if (!img) {
      img = new Image();
      img.src = url;
      imageCache.set(url, img);
    }
    return new RotateIcon({ url: url, img: img });
  };
  
  RotateIcon.prototype.setRotation = function (options) {
    const angle = options.deg ? (options.deg * Math.PI) / 180 : options.rad;
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));

    // Scale down với height giảm nhiều hơn width
    const scaleWidth = 0.65;
    const scaleHeight = 0.55;
    const targetWidth = this.options.width * scaleWidth;
    const targetHeight = this.options.height * scaleHeight;

    // Tính bounding box theo góc xoay
    const newWidth = targetWidth * cos + targetHeight * sin;
    const newHeight = targetWidth * sin + targetHeight * cos;

    if (!this._canvas) {
      this._canvas = document.createElement('canvas');
    }
    this._canvas.width = newWidth;
    this._canvas.height = newHeight;

    const ctx = this._canvas.getContext("2d");
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    ctx.clearRect(0, 0, newWidth, newHeight);

    ctx.save();
    ctx.translate(newWidth / 2, newHeight / 2);
    ctx.rotate(angle);
    ctx.translate(-targetWidth / 2, -targetHeight / 2);

    const draw = () => {
      ctx.drawImage(this.rImg, 0, 0, targetWidth, targetHeight);
      ctx.restore();
      this._hasDrawn = true;
    };

    if (this.rImg.complete) {
      draw();
    } else {
      this.rImg.onload = draw;
    }

    return this;
};

/**
 * URL ảnh đã xoay, hoặc `null` khi chưa vẽ được.
 *
 * Trả `null` thay vì `toDataURL()` của canvas rỗng: phía gọi thấy null sẽ dùng thẳng ảnh `.svg`
 * gốc — xe hiện đúng chỗ, chỉ là chưa xoay theo hướng, và nhịp sau sẽ có bản xoay. Một chiếc xe
 * chưa xoay vẫn hơn một chiếc xe biến mất.
 */
RotateIcon.prototype.getUrl = function () {
  if (!this._hasDrawn) {
    this.setRotation({ deg: 0 });
  }
  if (!this._hasDrawn || !this._canvas) return null;
  return this._canvas.toDataURL();
};

/** Kích thước ảnh đã xoay, hoặc `null` khi chưa vẽ được (canvas lúc đó là 0×0). */
RotateIcon.prototype.getSize = function () {
  if (!this._hasDrawn) {
    this.setRotation({ deg: 0 });
  }
  if (!this._hasDrawn || !this._canvas) return null;
  return [this._canvas.width, this._canvas.height];
};

export default RotateIcon;
